import { UUID } from "gen/proto/uuid/models_pb"

export const isID = (id?: UUID): id is UUID => !!id
